<template>
  <div
    v-if="
      item && item.id
    "
    class="item">
    <div class="heading">
      <div class="icon">
        <img
          :src="item.icon"
          @error="
            event => imgError(event)
          "
        />
      </div>
      <div class="content">
        <div class="name">
          <p class="code">
            {{ item.code }}
          </p>
          <p class="ellipsis">
            {{ name.tha }}
          </p>
        </div>
        <p class="pin">
          <span
            v-if="
              item.location
            ">
            <i class="el-icon-location" /> {{ item.location }}
          </span>
          <span v-else class="unknown">
            N/A
          </span>
        </p>
      </div>
    </div>
    <div class="action">
      <el-button
        icon="el-icon-user"
        type="sc-asset-light"
        @click="
          () => user(item.id)
        ">
        ลูกบ้าน
      </el-button>
      <el-button
        icon="el-icon-edit"
        type="sc-asset"
        @click="
          () => edit(item.id)
        ">
        แก้ไข
      </el-button>
    </div>
  </div>
</template>

<script lang="js">

export default {
  props: {
    project: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data: () => ({
    item: {
      code: null,
      id: null,
      icon: null,
      name: {
        tha: null,
        eng: null
      },
      location: null,
      created_at: null
    }
  }),
  computed: {
    name () {
      return this.item.name
    },
  },
  mounted() {
    this.item = this.project
  },
  watch: {
    project: {
      handler (value) {
        this.item = value
      },
      deep: true
    }
  },
  methods: {
    imgError(e) {
       e.target.src = 'https://www.scasset.com/images/sca-orange.svg'
    },
    user(id) {
      alert(`กำลังทำจ้า ${id}`)
    },
    edit(id) {
      
      // Update Project
      this.$router.push({
        name: 'nonsc-project-update', params: { id }
      })
    }
  }
}

</script>

<style lang="css" scoped>

.item {
  align-items : center;
  gap         : var(--size-md);
  padding     : var(--size-md);
}

p {
  line-height: var(--size-lg);
}

.item .heading {
  display     : flex;
  flex        : 1;
  gap         : var(--size-md);
  align-items : center;
  overflow    : hidden;
}
.item .icon {
  flex: none;
}
.item .content {
  flex            : 1;
  display         : flex;
  justify-content : space-between;
  overflow        : hidden;
}
.item .content .name {
  flex      : 5;
  overflow  : hidden;
}
.item .content .pin {
  flex        : 2;
  display     : flex;
  align-items : center;
}
.item .action {
  flex            : none;
  display         : flex;
  align-items     : center;
  justify-content : space-between;
  gap             : var(--size-sm);
}
.item .action [class^=el-button] {
  padding: 0 var(--size-sm);
}

.code {
  font-weight : bold;
  font-size   : calc(.125rem + var(--size-md));
}

.icon img {
  width         : 4rem;
  aspect-ratio  : 1/1;
  object-fit    : contain;
  border-radius : var(--size-sm);
}

@media screen and (max-width: 1280px) {
  
  .item {
    padding         : var(--size-sm);
    flex-direction  : column;
    align-items     : flex-end;
    gap             : var(--size-xs);
  }
  
  .item .heading,
  .item .action {
    width           : 100%;
    justify-content : flex-end;
  }

  .item .content .pin {
    align-items     : flex-start;
    justify-content : flex-end;
  }
}

@media screen and (max-width: 480px) {

  .item .content {
    gap             : var(--size-xs);
    flex-direction  : column;
  }
}


</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/project/NonScProjectListItem.vue